/**
 * The line Google asks for when the reCAPTCHA badge is hidden (C-170). App
 * Check renders its reCAPTCHA Enterprise widget inside a `display: none` div
 * (`makeDiv` in `@firebase/app-check`), so the badge never shows: the forms
 * whose requests carry an App Check token (`lib/app-check.ts`) say it in text
 * instead, and link to the Privacy Policy section that explains it.
 *
 * Text comes in from the caller's locale bundle; `href` is built with
 * `legalUrl(locale, "/privacy#recaptcha")`.
 */
export function RecaptchaNotice({
  text,
  linkText,
  href,
}: {
  text: string;
  linkText: string;
  href: string;
}) {
  return (
    <p className="mt-6 text-caption text-fg-muted leading-relaxed">
      {text}{" "}
      <a href={href} className="underline hover:text-fg-default" target="_blank" rel="noreferrer">
        {linkText}
      </a>
    </p>
  );
}
